import { RouteId } from './routes';

export const isBoardRoute = (routeId: RouteId): boolean => {
  const routes = [
    RouteId.BOARD,
    RouteId.BOARD_DASHBOARD,
    RouteId.BOARD_REFERRAL,
  ];

  return routes.some((route) => route === routeId);
};
